var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperSheet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55 22C4.81667 22 4.19584 21.7458 3.6875 21.2375C3.17917 20.7292 2.925 20.1083 2.925 19.375V16.25H6.1V2L7.6 3.5L9.1 2L10.575 3.5L12.075 2L13.575 3.5L15.075 2L16.575 3.5L18.075 2L19.575 3.5L21.075 2V19.375C21.075 20.1083 20.8208 20.7292 20.3125 21.2375C19.8042 21.7458 19.1833 22 18.45 22H5.55ZM18.45 20.5C18.7833 20.5 19.0542 20.3958 19.2625 20.1875C19.4708 19.9792 19.575 19.7083 19.575 19.375V4.5H7.6V16.25H17.325V19.375C17.325 19.7083 17.4292 19.9792 17.6375 20.1875C17.8458 20.3958 18.1167 20.5 18.45 20.5ZM5.525 20.5H15.825V17.75H4.425V19.375C4.425 19.7083 4.52917 19.9792 4.7375 20.1875C4.94584 20.3958 5.20834 20.5 5.525 20.5Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92505 6.9502V8.4502H14.925V6.9502H8.92505Z",
    fill: "#208C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92505 10.3002V11.8002H14.925V10.3002H8.92505Z",
    fill: "#208C72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7251 8.2252C16.8751 8.3752 17.05 8.4502 17.25 8.4502C17.45 8.4502 17.625 8.3752 17.775 8.2252C17.925 8.0752 18 7.9002 18 7.7002C18 7.5002 17.925 7.3252 17.775 7.1752C17.625 7.0252 17.45 6.9502 17.25 6.9502C17.05 6.9502 16.8751 7.0252 16.7251 7.1752C16.5751 7.3252 16.5 7.5002 16.5 7.7002C16.5 7.9002 16.5751 8.0752 16.7251 8.2252Z",
    fill: "#208C72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7251 11.4502C16.8751 11.6002 17.05 11.6752 17.25 11.6752C17.45 11.6752 17.625 11.6002 17.775 11.4502C17.925 11.3002 18 11.1252 18 10.9252C18 10.7252 17.925 10.5502 17.775 10.4002C17.625 10.2502 17.45 10.1752 17.25 10.1752C17.05 10.1752 16.8751 10.2502 16.7251 10.4002C16.5751 10.5502 16.5 10.7252 16.5 10.9252C16.5 11.1252 16.5751 11.3002 16.7251 11.4502Z",
    fill: "#208C72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperSheet1);
export default __webpack_public_path__ + "static/media/paper-sheet-1.fbbdbcff9ad96462cd5940dd09213623.svg";
export { ForwardRef as ReactComponent };